<!-- TODO: definire il testo -->
<app-toolkit-page-title title="Contatti"></app-toolkit-page-title>
<div class="row">
    <div class="col-12 blocco-contatti">
        <div class="testo-contatti">
            Per informazioni di carattere generale e per la registrazione:
        </div>
    </div> 
    <div class="col-12 blocco-contatti">
        <div class="testo-contatti">
            <b>Andrea Piccin</b> <br>
            TERRITORIO E SISTEMI VERDI - ASSETTO IDROGEOLOGICO, RETICOLI E DEMANIO IDRICO<br>
            Tel. 02 6765 4492 - email <a href="mailto:andrea_piccin@regione.lombardia.it">andrea_piccin@regione.lombardia.it</a>
        </div>
    </div>
              
    <div class="col-12 blocco-contatti">
        <div class="testo-contatti">
            <b>Marina Credali</b> <br>
            TERRITORIO E SISTEMI VERDI - ASSETTO IDROGEOLOGICO, RETICOLI E DEMANIO IDRICO<br>
            Tel. 02 6765 4026 - email <a href="mailto:marina_credali@regione.lombardia.it">marina_credali@regione.lombardia.it</a>
        </div>
    </div>
</div>

<div class="d-flex justify-content-start mb-3">
    <div class="linea-meta"></div>
</div>

<div class="row">
    <div class="col-12 blocco-contatti">
        <div class="testo-contatti">
            Per:
        </div>
        <div class="testo-contatti">
            - Problemi di registrazione e autenticazione utente
        </div>
        <div class="testo-contatti">
            - Informazioni o segnalazioni di malfunzionamenti relativi al gestionale web delle ODS
        </div>
        <div class="testo-contatti">
            - Supporto tecnico relativo al viewer pubblico delle ODS
        </div>
    </div>
    <div class="col-12 blocco-contatti">
        <div class="testo-contatti">
            Inviare email a <a href="mailto:ods_assistenza@ariaspa.it">ods_assistenza@ariaspa.it</a>
        </div>
    </div>

</div>